import {BOOKING_STATUSES} from "./constant";
import React from "react";
import {staticImages} from "../../assets/images";
import {styled} from "@mui/material";

const CarSection = ({status, isDarkMode, compactOnShortScreen = false}) => {
    const imageProps = {
        $compactOnShortScreen: compactOnShortScreen,
    };

    return (<>
        {status === BOOKING_STATUSES.READY && <>
            <StyledGifImage
                {...imageProps}
                src={isDarkMode ? staticImages.clientCarParkedDarkGif : staticImages.clientCarParkedLightGif}
            />
        </>}
        {status === BOOKING_STATUSES.BOOKED && <>
            <StyledGifBooked
                {...imageProps}
                src={isDarkMode ? staticImages.clientCarBookedDarkGif : staticImages.clientCarBookedLightGif}
            />
        </>}
        {(status !== BOOKING_STATUSES.READY) && (status !== BOOKING_STATUSES.BOOKED) && <>
            <StyledImage
                {...imageProps}
                src={isDarkMode ? staticImages.clientCarLightsOnDark : staticImages.clientCarLightsOnLight}
            />
        </>}
    </>)
}

export default CarSection

const carImageStyles = ({ $compactOnShortScreen }) => `
      width: auto;
      height: 314px;
      object-fit: cover;
      ${$compactOnShortScreen ? `
      @media (max-height: 780px) {
        height: 268px;
      }` : ''}
`;

const StyledImage = styled('img')(
    ({ $compactOnShortScreen }) => `
      ${carImageStyles({ $compactOnShortScreen })}
      margin-top: 30px;
      ${$compactOnShortScreen ? `
      @media (max-height: 780px) {
        margin-top: 20px;
      }` : ''}
      `
)

const StyledGifBooked = styled('img')(carImageStyles);

const StyledGifImage = styled('img')(
    ({ $compactOnShortScreen }) => `
      ${carImageStyles({ $compactOnShortScreen })}
      margin-bottom: 30px;
      ${$compactOnShortScreen ? `
      @media (max-height: 780px) {
        margin-bottom: 20px;
      }` : ''}
      `
);
